:host {
  display: block;
  position: fixed;
  top: var(--padding-xl);
  right: var(--padding-xl);
  z-index: 9999;
  pointer-events: none;
}

.toast-list {
  display: flex;
  flex-direction: column;
  gap: var(--margin);
  align-items: flex-end;
}

.toast {
  pointer-events: auto;
  background: var(--color-bg-primary);
  border: var(--border);
  border-radius: var(--border-radius);
  padding: var(--padding-xl);
  min-width: 300px;
  max-width: 500px;
  box-shadow: var(--box-shadow);
  display: flex;
  align-items: flex-start;
  gap: var(--margin);
  animation: slideIn 0.3s ease-out;
}

.toast.removing {
  animation: slideOut 0.3s ease-out forwards;
}

.toast-icon {
  font-size: var(--font-size-l);
  flex-shrink: 0;
  line-height: 1;
}

.toast-content {
  flex: 1;
  font-size: var(--font-size-s);
  color: var(--color-text-primary);
  word-wrap: break-word;
}

.toast-close {
  background: transparent;
  border: none;
  color: var(--color-text-secondary);
  cursor: pointer;
  padding: 0;
  font-size: var(--font-size-l);
  line-height: 1;
  flex-shrink: 0;
  opacity: 0.7;
}

.toast-close:hover {
  opacity: 1;
}

.toast-success {
  border-left: 4px solid var(--color-success);
}

.toast-success .toast-icon {
  color: var(--color-success);
}

.toast-error {
  border-left: 4px solid var(--color-danger);
}

.toast-error .toast-icon {
  color: var(--color-danger);
}

.toast-warning {
  border-left: 4px solid var(--color-warning);
}

.toast-warning .toast-icon {
  color: var(--color-warning);
}

.toast-info {
  border-left: 4px solid var(--color-info);
}

.toast-info .toast-icon {
  color: var(--color-info);
}

@keyframes slideIn {
  from {
    transform: translateX(calc(100% + var(--padding-xl)));
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(calc(100% + var(--padding-xl)));
    opacity: 0;
  }
}

@media (max-width: 768px) {
  :host {
    top: var(--padding);
    right: var(--padding);
    left: var(--padding);
  }

  .toast {
    min-width: auto;
    max-width: none;
  }

  .toast-list {
    align-items: stretch;
  }
}
